const matchFilterArrayIncludesArrayItem = (array: number[], filterArray: number[]) => {
  if (!array || !array.length || !filterArray || !filterArray.length){
    return true
  }

  return array.some(item => filterArray.includes(item))
}

export default matchFilterArrayIncludesArrayItem
